<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop (contratoenvio)="recibirContrato($event)"></app-menudesktop>
  </div>
  <div class="col-xs-12 col-md-8 scyr-interior">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <section>
      <h1>Domiciliación de factura</h1>
      <p>Facilítenos sus datos y procederemos a la domiciliación del pago de sus facturas en la mayor brevedad posible
      </p>
      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="get"
          action=""
        >
          <h2 class="line">Datos del solicitante</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos solicitante</legend>
            <div
              class="row"
              *ngIf="!contrato.Ficticio"
            >
              <div class="col-xs-12 col-sm-6 col-md-12">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'direccionSuministro'"
                  [setLabel]="'Dirección suministro'"
                  [setValue]="direccionSuministro"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="direccionSuministro = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'nombreSolicitante'"
                  [setLabel]="'Nombre y apellidos'"
                  [setValue]="nombreSolicitante"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="nombreSolicitante = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'dni'"
                  [setName]="'identificacionsolicitante'"
                  [setLabel]="'DNI'"
                  [setValue]="identificacionsolicitante"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="identificacionsolicitante = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'dni'"
                  [setName]="'emailSolicitante'"
                  [setLabel]="'Email'"
                  [setValue]="emailSolicitante"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="emailSolicitante = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'tel'"
                  [setName]="'telefonoSolicitante'"
                  [setLabel]="'Teléfono'"
                  [setValue]="telefonoSolicitante"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="telefonoSolicitante = $event"
                ></sacyr-input>
              </div>
            </div>
          </fieldset>

          <h2 class="line">Datos del pagador</h2>
          <fieldset>
            <legend class="sr-only">Formulario suministro</legend>
            <div
              class="row"
              *ngIf="isEmmasa"
            >
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="input-form input-check input-check__privacidad">
                  <input
                    type="checkbox"
                    [(ngModel)]="domiciliado"
                    id="domiciliado"
                    name="domiciliado"
                    (change)="Domiciliar()"
                  />
                  <label
                    for="domiciliado"
                    class="slct"
                  >DOMICILIADO
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'nombrePagador'"
                  [setLabel]="'Nombre y apellidos'"
                  [setValue]="nombrePagador"
                  [setRequired]="true"
                  (change)='Rellenar()'
                  (outValue)="nombrePagador = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="input-form input-select">
                  <label
                    for="tipoIdentidadPagador"
                    class="slct"
                  >Tipo de documento de identidad</label>
                  <div class="select">
                    <select
                      name="tipoIdentidadPagador"
                      [(ngModel)]="tipoIdentidadPagador"
                      (change)='Rellenar()'
                      required
                    >
                      <option
                        value=""
                        selected
                      >Seleccione tipo de documento</option>
                      <option value="0">DNI</option>
                      <option value="1">CIF</option>
                      <option value="2">NIE</option>
                      <option value="3">PASAPORTE</option>
                      <option value="SD">Sin determinar</option>
                    </select>
                  </div>
                </div>
                <span
                  *ngIf="tipoIdentidadPagadorInputError == true"
                  class="error"
                >Seleccione un tipo de documento</span>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'identificacionPagador'"
                  [setLabel]="'Documento de identidad'"
                  [setValue]="identificacionPagador"
                  [setRequired]="true"
                  [setError]="identificacionPagadorInputError ? 'Introduzca un documento de identidad válido' : ''"
                  (change)='Rellenar()'
                  (outValue)="identificacionPagador = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="input-form input-select">
                  <label
                    for="nacionalidadPagador"
                    class="slct"
                  >Nacionalidad</label>
                  <div class="select">
                    <select
                      name="nacionalidadPagador"
                      [value]="paisPagador"
                      [(ngModel)]="nacionalidadPagador"
                      (change)='Rellenar()'
                      required
                    >
                      <option
                        *ngFor="let country of paises"
                        [value]="country.value"
                        [disabled]="country.disabled"
                      >{{country.text}}</option>
                    </select>
                  </div>
                </div>
                <span
                  *ngIf="nacionalidadPagadorInputError == true"
                  class="error"
                >Seleccione una nacionalidad</span>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="input-form input-select">
                  <label
                    for="paisPagador"
                    class="slct"
                  >País</label>
                  <div class="select">
                    <select
                      name="paisPagador"
                      [value]="paisPagador"
                      [(ngModel)]="paisPagador"
                      (change)='Rellenar()'
                      required
                    >
                      <option
                        *ngFor="let country of paises"
                        [value]="country.value"
                        [disabled]="country.disabled"
                      >{{country.text}}</option>
                    </select>
                  </div>
                </div>
                <span
                  *ngIf="paisPagadorInputError == true"
                  class="error"
                >Seleccione una país</span>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'provinciaPagador'"
                  [setLabel]="'Provincia'"
                  [setValue]="provinciaPagador"
                  [setRequired]="true"
                  (change)='Rellenar()'
                  (outValue)="provinciaPagador = $event"
                ></sacyr-input>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'poblacionPagador'"
                  [setLabel]="'Población'"
                  [setValue]="poblacionPagador"
                  [setRequired]="true"
                  (change)='Rellenar()'
                  (outValue)="poblacionPagador = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'direccionPagador'"
                  [setLabel]="'Dirección'"
                  [setValue]="direccionPagador"
                  [setRequired]="true"
                  [setError]="direccionPagadorInputError ? 'Introduzca una dirección válida' : ''"
                  (change)='Rellenar()'
                  (outValue)="direccionPagador = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'codigoPostalPagador'"
                  [setLabel]="'Código Postal'"
                  [setValue]="codigoPostalPagador"
                  [setRequired]="true"
                  [setError]="codigoPostalPagadorInputError ? 'Introduzca un código postal válida' : ''"
                  (change)='Rellenar()'
                  (outValue)="codigoPostalPagador = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'bic'"
                  [setLabel]="'BIC'"
                  [setValue]="bic"
                  [setRequired]="!isEmmasa"
                  [setError]="!isEmmasa && bicInputError ? 'Introduzca un BIC válido' : ''"
                  (change)='Rellenar()'
                  (outValue)="bic = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'iban'"
                  [setLabel]="'IBAN'"
                  [setValue]="iban"
                  [setRequired]="true"
                  [setError]="ibanInputError ? 'Introduzca un IBAN válido' : ''"
                  (change)='Rellenar()'
                  (outValue)="iban = $event"
                ></sacyr-input>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </section>
    <div
      *ngIf="!contrato.Ficticio"
      class="input-form input-button"
    >
      <button
        (click)="enviar($event)"
        type="submit"
        class="btn-default"
        value=""
      >Enviar</button>
    </div>
  </div>

  <!-- MODAL -->
  <sacyr-modal
    [setTemplateRef]="modal_content"
    [showModal]="showModal()"
    (closeModal)="closeModal()"
  ></sacyr-modal>

  <ng-template #modal_content>

    <ng-container *ngIf="_showDomiciliado">
      <div>
        <h1 *ngIf="domiciliado">Alta\Modificación Domiciliación</h1>
        <label *ngIf="domiciliado">Cumplimente los campos para proceder a la domiciliación de sus facturas
        </label>
        <h1 *ngIf="!domiciliado">Baja Domiciliación</h1>
        <label *ngIf="!domiciliado">Si envia su formulario de este modo, se procederá a dar la baja de la domiciliación
          de sus
          próximas facturas
        </label>
      </div>
    </ng-container>
  </ng-template>
